import { BaseReq, BaseResp, UpdaterResp } from "@/core/interface";

export class DepartmentReq extends BaseReq {
  name: string = ""; // 部门名称
  parentId: string | undefined = undefined; // 上级部门ID
  remark: string = ""; // 备注
  type: string = ""; // 组织类别
}

export class DepartmentListRecord extends UpdaterResp {
  id: string = ""; // 部门ID
  name: string = ""; // 部门名称
  parentId: string = ""; // 上级部门ID
  remark: string = ""; // 备注
  type: string = ""; // 组织类别

  bizNo: string = ""; // 部门编码
  typeShowName: string = ""; // 组织类别显示值
  pathBizNo: string = ""; // 部门编码层级
  hasChildren: boolean = false; // 是否有下级
  isLeaf?: boolean = false; // 是否为叶子节点
  children?: DepartmentListRecord[] = []; // 下级部门
}

export class DepartmentListResp extends BaseResp {
  records: DepartmentListRecord[] = [];
}

export class DepartmentSimpleRecord {
  id: string = ""; // 部门ID
  name: string = ""; // 部门名称
  hasChildren: boolean = false;
  hasEmployee: boolean = false;
  parentId: string = "";
  isLeaf: boolean = false;
  children?: DepartmentSimpleRecord[] = [];
}

export class DepartmentSimpleListReq extends BaseReq {
  parentId: string = "";
  needChildren: boolean | undefined = undefined; // 是否包含子节点
  needEmployee: boolean | undefined = undefined; // 是否包含员工
  limit: number | undefined = undefined; // 限制条数
  staffType: string = 'no_type'; // 是否包含劳务班组
  activatedStatus: number | undefined = undefined;//是否包括试用员工
}

export class DepartmentSimpleListResp extends BaseResp {
  records: DepartmentSimpleRecord[] = [];
}

export class DepartmentUserRecord {
  tenantUserId: string = "";
  userName: string = "";
  realName: string = "";
  mobile:string = "";
}

export class DepartmentUserResp {
  records: DepartmentUserRecord[] = [];
}

export class DepartmentDetailResp extends UpdaterResp {
  id: string = ""; // 部门ID
  name: string = ""; // 部门名称
  parentId: string = ""; // 上级部门ID
  remark: string = ""; // 备注
  type: string = ""; // 组织类别

  bizNo: string = ""; // 部门编码
  typeShowName: string = ""; // 组织类别显示值
  pathBizNo: string = ""; // 部门编码层级
  staffCount:number;//部门下员工人数
}
